import Carousel from 'react-material-ui-carousel';
import { useSaveMode } from '../../hooks/useSaveMode';
import { useStyles } from './customCarousel.styles';

interface CarouselProps {
  children: React.ReactNode;
}

function CustomCarousel({ children }: CarouselProps) {
  const { cx, classes } = useStyles();
  const isSaveMode = useSaveMode();

  return (
    <Carousel
      className={cx(classes.carousel, isSaveMode ? classes.disabled : '')}
      autoPlay
      indicators={false}
      swipe
      cycleNavigation
      navButtonsAlwaysVisible
      fullHeightHover
      interval={8000}
      navButtonsProps={{
        style: {
          backgroundColor: 'transparent',
        },
      }}
    >
      {children}
    </Carousel>
  );
}

export { CustomCarousel };
